import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'

import { baseApi } from '~/shell/api/rtk/baseApi'
import { forbiddenMiddleware } from '~/shell/redux/forbiddenMiddleware'
import { forbiddenSlice } from '~/shell/redux/forbiddenSlice'
import { unauthorizedMiddleware } from '~/shell/redux/unauthorizedMiddleware'

/**
 * Creates and configures the suite's Redux store, including the RTK Query middleware every app's
 * generated client injects its endpoints into.
 *
 * Named for what it is rather than for a product: there is one store per suite, and this is a shell
 * module, so naming an app here would be the shell depending on one. Tests call it to build an
 * isolated store per render.
 */
export const createStore = () => {
  const suiteStore = configureStore({
    reducer: {
      [baseApi.reducerPath]: baseApi.reducer,
      [forbiddenSlice.name]: forbiddenSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        baseApi.middleware,
        forbiddenMiddleware,
        unauthorizedMiddleware,
      ),
  })

  setupListeners(suiteStore.dispatch)

  return suiteStore
}

export const store = createStore()

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
